import type { RootDispatch } from "../index";
import { useDispatch as useUntypedDispatch } from "react-redux";

const useDispatch = () => useUntypedDispatch<RootDispatch>();

export default useDispatch;
